import React from 'react'
import { Box, Button, useColorModeValue } from '@chakra-ui/react'
import { GREEK_LANG } from '../../lib/constants'
import { useTranslation } from 'react-i18next'
import Flag from 'react-world-flags';

const LangSwitcher = () => {
    const { i18n } = useTranslation()
    const textColorHover = useColorModeValue('brand.blue', 'brand.yellow')
    const textColor = useColorModeValue('brand.white', 'brand.white')
    const currentLang = i18n.language

    return (
        <Box>
            <Button
                p={0}
                bg={'transparent'}
                px={0}
                minW={8}
                ml={1}
                _hover={{
                    textDecoration: 'none',
                    cursor: 'pointer',
                    bg: 'transparent',
                    color: textColorHover,
                }}
                color={textColor}
                onClick={() =>
                    currentLang === GREEK_LANG
                        ? (window.location.href = '/?lang=en')
                        : (window.location.href = '/?lang=el')
                }
            >
                {currentLang !== GREEK_LANG && <Flag code="gr" style={{ width: '36px' }} />}
                {currentLang === GREEK_LANG && <Flag code="gb" style={{ width: '36px' }} />}
            </Button>
        </Box>
    )
}

export default LangSwitcher
